export default __webpack_public_path__ + "static/media/MinecadiaDesktop.ad56f25e.png";